<template>
    <div class="SITEPLAN">

        <div class="sitecontent">
            <iframe width="100%" height="100%" :src="Main.mapserve+'/091avenuesouth.html'" frameborder="0"></iframe>
        </div>
            <div class="left_imgcontent">
      <h2 style="margin-top: 2vh;text-align: end; width: 80%">SITE PLAN</h2>
    </div>
        <!-- <div class="content">
            <img :src="Main.imgserve + '/SITEPLAN/01.png'" alt="">
        </div>

        <div class="left_imgcontent">
            <img :src="Main.imgserve + '/SITEPLAN/02.png'" alt="">
        </div> -->

    </div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    },
    methods:{

    },
    mounted(){

    }
}
</script>

<style lang="less">
    
.SITEPLAN{
    width: 100%;
    height: 100%;
    .sitecontent{
        width: 100%;
        height: 100%;

    }
    .content{
        width: 75%;
        height: 100%;
    }

}

</style>